import {apiVersion} from '.';

const baseURL = `${apiVersion.base}/Normal/SmartAddress`;
const baseURL2 = `${apiVersion.base}/Normal/BasicAddress`;

export const {
    verifyId,
    updateBasicAddress,
    livenessCheck,
    updateAddress,
    validateAddress,
    getSavedAddress,
    getSavedBasicAddress,
    validateBasicAddress,
} = {
    verifyId: `${baseURL}/VerifyID`,
    livenessCheck: `${baseURL}/Liveness`,
    updateAddress: `${baseURL}/UpdateAddress`,
    updateBasicAddress: `${baseURL2}/AddDetails`,
    validateAddress: `${baseURL}Validation`,
    getSavedBasicAddress: `${baseURL2}/VerificationDetails`,
    validateBasicAddress: `${baseURL2}Validation`,
    getSavedAddress: `${baseURL}/VerificationDetails`,
};
